import { Typography, Box } from "@mui/material";
import React from "react";
import "./homepage.css";
import Tilt from "react-parallax-tilt";

function Card() {
  let i = 1;
  const str = [
    "  #include<bits/>stdc++.h>",
    "  using namespace std;",
    "  int main() {",
    "      ",
    "      cout<<'Divyesh Vyas';",
    "      ",
    "      return MyPortfolio();",
    "      ",
    "      } ",
  ];
  return (
    <Tilt>
      <Box
        sx={{
          backgroundColor: "rgb(35, 35, 35)",
        }}
        className="card">
        {str.map((line, key) => (
          <Typography
            sx={{
              color: "#f6f6f6",
            }}
            id={key}>
            {line}
          </Typography>
        ))}
      </Box>
    </Tilt>
  );
}

export default Card;
